<script>
import VueSelect from "vue-select";
import TurbineService from "@/services/TurbineService";

export default {
    props: {
        selectMultiple: {
            type: Boolean,
            default: true
        }
    },
    components: { VueSelect },
    data() {
        return {
            loading: false,
            input: null,
            options: []
        };
    },
    methods: {
        async search(searchTerm) {
            this.options = [];

            try {
                const { data } = await TurbineService.search(searchTerm || "");
                for (const item of data.data) {
                    this.options.push({ value: item.value, label: item.name });
                }
            } catch (e) {
                console.log("Fetch error:", e);
            }
        },
        choose() {
            this.$emit("choose-item", this.input);
        }
    }
};
</script>

<template>
    <div>
        <vue-select
            @open="search"
            @input="choose"
            v-model="input"
            class="bg-white mb-3"
            :placeholder="$t('service.search_placeholder')"
            :multiple="selectMultiple"
            :options="options"
            :loading="loading"
        />
    </div>
</template>
